import classnames from 'classnames';

import style from './TitleSectionWrapper.module.css';

export const TitleSectionWrapper = (props) => {
    const { children, withBackground, className, wrapperInnerClassName } =
        props;
    const wrapperInnerStyles = classnames(
        style.wrapperInner,
        withBackground && style.wrapperInnerWithBackgroundStyle,
        wrapperInnerClassName
    );

    return (
        <div className={classnames(style.TitleSectionWrapper, className)}>
            <div className={wrapperInnerStyles}>
                <div className={style.titleWrapper}>{children}</div>
            </div>
        </div>
    );
};
